import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_66: FaireProductEntity = {
  token: "legacy_prod_abbott-66",
  type: "product",
  name: "Gothica Lined Notebook 6×8 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/81d3342952deb2bec62460b30c683263003da83de8a578b4add3a6b1c1168a53.jpeg",
  priceDollars: 9,
  msrpDollars: 14,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_stationery-writing"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
